import PresupuestoAPI from '@/api/venta/presupuesto';

export default {
  namespaced: true,
  actions: {
    fetch_presupuesto(_, params) {
      return PresupuestoAPI.index(params);
    },
    get_presupuesto(_, id) {
      return PresupuestoAPI.show(id);
    },
    create_presupuesto(_, data) {
      return PresupuestoAPI.create(data);
    },
    update_presupuesto(_, { id, data }) {
      return PresupuestoAPI.update(id, data);
    },
    destroy_presupuesto(_, id) {
      return PresupuestoAPI.destroy(id);
    },
    cambiar_estado_presupuesto(_, { id, estado }) {
      return PresupuestoAPI.cambiarEstado(id, estado);
    },
  },
};
